import React, { useState } from 'react';
import { SiteSection, SiteSectionHeader } from '../../../../components/site';
import type { PlatformSubpageConfig } from '../types';

export const MobileAppsContent: React.FC<{ config: PlatformSubpageConfig }> = ({ config }) => {
  const [theme, setTheme] = useState<'light' | 'dark'>('light');

  return (
    <SiteSection className="platform-sub-interactive">
      <SiteSectionHeader
        eyebrow="INTERACTIVE"
        title={config.sections.title}
        subtitle={config.sections.subtitle}
        align="center"
      />
      <div className="platform-sub-theme-toggle" role="group" aria-label="App theme preview">
        <button
          type="button"
          className={`platform-sub-chip${theme === 'light' ? ' platform-sub-chip--active' : ''}`}
          aria-pressed={theme === 'light'}
          onClick={() => setTheme('light')}
        >
          Light
        </button>
        <button
          type="button"
          className={`platform-sub-chip${theme === 'dark' ? ' platform-sub-chip--active' : ''}`}
          aria-pressed={theme === 'dark'}
          onClick={() => setTheme('dark')}
        >
          Dark
        </button>
      </div>
      <div
        className={`platform-sub-phone platform-sub-phone--${theme}`}
        aria-label={`App preview in ${theme} mode`}
      >
        <div className="platform-sub-phone__screen">
          <p className="platform-sub-phone__brand">Your Brand</p>
          <div className="platform-sub-phone__card">
            <span>Living Room</span>
            <strong>4 devices online</strong>
          </div>
          <div className="platform-sub-phone__card">
            <span>Smart Plug</span>
            <strong>ON</strong>
          </div>
          <div className="platform-sub-phone__card">
            <span>Scene</span>
            <strong>Good Night</strong>
          </div>
        </div>
      </div>
    </SiteSection>
  );
};
